import { render, staticRenderFns } from "./PaginationPageSizeSelect.vue?vue&type=template&id=35e6f3f2"
import script from "./PaginationPageSizeSelect.vue?vue&type=script&lang=js"
export * from "./PaginationPageSizeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports